import { dayjs } from 'utils/libs/dayjs'

const relativeFromNow = (date) => dayjs(date).fromNow()

export { relativeFromNow }
